import Vue from 'vue'
import VueGettextExtended from './plugin'
import { languageVmMixin, defaultLanguage } from './mixin'

const getAvailableLanguages = () => {
  if (process.env.VUE_APP_AVAILABLE_LANGUAGES) {
    const languages = JSON.parse(process.env.VUE_APP_AVAILABLE_LANGUAGES)
    return languages.reduce((acc, lang) => ({ ...acc, [lang]: lang }), {}) // transform array to object
  }
  return {}
}

// Register extended vue-gettext
Vue.use(VueGettextExtended, {
  silent: true,
  autoAddKeyAttributes: true,
  defaultLanguage: defaultLanguage, // initial value, will be overriden with user locale
  muteLanguages: ['dummy'],
  translations: {},
  availableLanguages: getAvailableLanguages(),
  languageVmMixin
})
